import { TrackingPageModel } from '../tracking-page.model';
import { getAsset, getProductItems } from './helpers';
import {
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getImage,
  getLanguageMenu,
  white
} from './helpers';

export const lightroom: TrackingPageModel = {
  languageMenu: getLanguageMenu('Muli', '#162950ff'),
  searchPageInput: {
    backgroundColor: white,
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Muli', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Muli', '#6d6d6dff')
  },
  background: {
    color: '#f8f8f8ff',
    useBackgroundImage: false,
    imageUrl: getImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#da2f0cff',
    linksUnderline: true,
    backgroundColor: '#f8f8f8ff',
    headerBackground: '#f8f8f8ff',
    footerBackground: '#f8f8f8ff',
    borderColor: '#6d6d6d33',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Muli', '#6d6d6dff')
  },
  orderCard: {
    borderRadius: 2,
    borderWidth: 1,
    borderColor: '#6d6d6d33',
    backgroundColor: '#f8f8f8ff',
    shadow: 'none',
    footerBackground: '#f8f8f8ff',
    headerBackground: '#f8f8f8ff',
    linksColor: '#da2f0cff',
    linksUnderline: true,
    ...getFontConfig('Muli', '#6d6d6dff')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 19,
    ...getFontConfig('Muli', '#6d6d6dff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 16,
    ...getFontConfig('Noto Sans KR', '#2a3447ff')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Muli', '#6d6d6dff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Muli', '#6d6d6dff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#162950ff',
    borderRadius: 2,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#cd2d2dff',
      borderColor: '#ffffffff',
      borderRadius: 2,
      borderWidth: 1,
      shadow: 'none',
      ...getFontConfig('Muli', '#ffffffff')
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: '#ffffff00',
      borderColor: '#ffffffff',
      borderRadius: 2,
      borderWidth: 1,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 20,
        ...getFontConfig('Muli', '#12244fff')
      },
      info: {
        alignment: 'left',
        fontSize: 11,
        ...getFontConfig('Muli', '#6d6d6dff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#ffffff00',
    borderColor: '#162950ff',
    borderRadius: 2,
    borderWidth: 2,
    shadow: 'none',
    ...getFontConfig('Muli', '#162950ff')
  },
  detailsButton: {
    on: null,
    backgroundColor: '#da2f0cff',
    borderColor: '#00ccffff',
    borderRadius: 2,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Source Sans Pro', white)
  },
  trackButton: {
    on: null,
    backgroundColor: '#da2f0cff',
    borderColor: '#ee7227',
    borderRadius: 2,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Muli', white)
  },
  pageScroll: {
    scrollColor: '#00000033',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(
    getAsset(
      '/images/themes/5c98ee273591d_lightroom-logo-0021eff6-7ea8-41ea-b82c-858d4989b3e5-360x.png'
    )
  ),
  socialIcons: getSocialIcons('#162950ff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: '#f8f8f8ff',
    borderColor: '#6d6d6d33',
    borderRadius: 2,
    borderWidth: 1,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Muli', '#6d6d6dff')
  },
  footer: {
    linksColor: '#da2f0cff',
    linksUnderline: true,
    backgroundColor: '#f8f8f8ff',
    ...getFooterItems(),
    ...getFontConfig('Muli', '#6d6d6dff')
  },
  header: {
    backgroundColor: '#f8f8f8ff'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: '#f8f8f8ff',
    borderColor: '#6d6d6d33',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: '#f8f8f8ff',
      borderColor: '#6d6d6d33',
      borderRadius: 2,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#da2f0cff',
        borderColor: '#00ccffff',
        borderRadius: 2,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Source Sans Pro', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 11,
        ...getFontConfig('Muli', '#6d6d6dff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Muli', '#6d6d6dff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Muli', '#2d314aff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#da2f0cff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: '#f8f8f8ff',
    borderColor: '#6d6d6d33',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: '#f8f8f8ff',
      borderColor: '#6d6d6d33',
      borderRadius: 2,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#da2f0cff',
        borderColor: '#00ccffff',
        borderRadius: 2,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Source Sans Pro', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 11,
        ...getFontConfig('Muli', '#6d6d6dff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Muli', '#6d6d6dff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Muli', '#312e43ff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#da2f0cff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
